import { render } from "./RegistrationPending.vue?vue&type=template&id=6f496a52&scoped=true"
import script from "./RegistrationPending.vue?vue&type=script&lang=js"
export * from "./RegistrationPending.vue?vue&type=script&lang=js"

import "./RegistrationPending.vue?vue&type=style&index=0&id=6f496a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f496a52"]])

export default __exports__